import Vue from "vue";
import dayjs from "dayjs";

// 定义一个名为formatDate的过滤器
Vue.filter(
  "date",
  function (value, formatString = "YYYY年MM月DD日 HH:mm:ss") {
    // 使用Day.js来格式化时间
    value = value * 1000;
    return dayjs(value).format(formatString);
  }
);
